import { useEffect, useState } from "react";
import { Pagination, Thumbs } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

const Reviews = () => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [data, setData] = useState("");

  useEffect(() => {
    const request = async () => {
      const result = fetch(
        "https://codefling.com/api/downloads/files/3161/reviews",
        {
          headers: {
            Authorization:
              "Bearer 149a767568ff44cda936564042bbed35_fa106edcc36ff2aa4b9047e5d6b61f7a326b4adecf3542c85d0273b40d6ca13f",
          },
        }
      );

      const json = await result.json();
      console.log(json);
    };
  }, []);

  return (
    <section className="review-section">
      <div className="container">
        <h5 className="section-title" data-aos="fade-up">
          REVIEWS
        </h5>
        <div data-aos="fade-left">
          <Swiper
            modules={[Thumbs, Pagination]}
            thumbs={{ swiper: thumbsSwiper }}
            spaceBetween={20}
            pagination={{
              clickable: true,
              el: ".pagination-dots",
            }}
            breakpoints={{
              500: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 2,
              },
              992: {
                slidesPerView: 3,
              },
            }}
          >
            {data1.map((item, index) => (
              <SwiperSlide key={index}>
                <ReviewItem item={item} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div
          className="pagination-dots"
          style={{ background: `url('/img/dash-line.png')` }}
        ></div>
      </div>

      <img
        src="/img/panel-img-ellipsis.png"
        className="panel-img-ellipsis"
        alt=""
      />
    </section>
  );
};
const ReviewItem = ({ item }) => {
  return (
    <>
      <div className="review-item">
        <div className="inner">
          <div className="top">
            <img src={item.img} className="img" alt="" />
            <div className="cont">
              <div>
                <h6>{item.name}</h6>
              </div>
              <img src="/img/star2.png" alt="" />
            </div>
          </div>
          <div className="line"></div>
          <blockquote>{item.description}</blockquote>
        </div>
      </div>
    </>
  );
};

const data1 = [
  {
    img: process.env.PUBLIC_URL + "/img/review.png",
    name: "FrothyBoy",
    stars: 5,
    description:
      "In my opinion the Carbon framework is awesome!  Outside of all the skeptics tossed around through the grape vine, Carbon has a lot of pros. Just the simplicity itself of installing and configuring Carbon can have a server up in going in less than a couple of days.",
  },
  {
    img: "https://codefling.com/uploads/monthly_2022_08/eeuY1WI.thumb.png.4d4541ab089a2da5b0b4b1648ce7d670.png",
    name: "The Friendly Chap",
    stars: 5,
    description:
      "It's good. I like the Carbon platform, as it can integrate both Harmony mods and Oxide, and it has a host of great perks for those developing plugins for Rust. Excellent work, Carbon team. ",
  },
  {
    img: "https://codefling.com/uploads/monthly_2022_03/imported-photo-11260.thumb.jpeg.837bc7465a144cf8751cf4929291604f.jpeg",
    name: "LaernuTairos",
    stars: 5,
    description:
      "So after having some 1 off issues getting setup, (With 180+ mods its bound to happen to at least 2/3) this server is FLYING with 183 mods going. It's insane how much smoother the server feels compared to a few hours ago using Oxide. I'm even seeing some functionality that was lost in some mods on oxide being restored & working here, which is kind of odd.",
  },
  {
    img: "https://codefling.com/uploads/monthly_2024_02/imported-photo-8132.thumb.png.479b1cbd76b5c48a0755c47364dadb94.png",
    name: "GangstaPichu",
    stars: 5,
    description:
      "I love Carbon! Best thing we've switched to. Been using it for months now for all 5 of our servers. Has enabled us to use plugins together we wouldn't have been able to with Oxide! Not only that, but I really love being able to use /cpanel while in-game as it has made my life sooooooo MUCH easier!",
  },
  {
    img: "https://codefling.com/uploads/monthly_2023_12/SmokingDwarf.thumb.jpg.4d37c29f9f42e6705c105b2a7cf202e0.jpg",
    name: "feldspar333",
    stars: 5,
    description:
      "After a successful switch to Carbon my test server, the implementation was uneventful on the public server.  One mod, Monument Addons, did not compile, but commenting out a single line allowed it to work. Carbon is quite intuitive and seems very smooth and quick.  The integrated control panel with commonly used modules is very handy and efficient.  I reduced my mod count by eight or so.",
  },
  {
    img: "https://codefling.com/uploads/monthly_2023_02/channels4_profile.thumb.jpg.a197a9478476aaf1e8882a16b968380f.jpg",
    name: "Brandiz",
    stars: 5,
    description:
      "This modding framework is such a performance gain, I have almost 70 plugins on my server, and even with that many plugins, only 1/3rd of all the hook are being actively used. That's a massive performance gain for my server! The installation is pretty straight forward, I ran into some small bumps, but Raul over at the Carbon discord was very kind and helpful and helped me to get Carbon running on the server with ease. ",
  },
  {
    img: "https://codefling.com/uploads/monthly_2023_01/imported-photo-1388.thumb.png.9242fcf693bdc5f59833c3f379828665.png",
    name: "Ned Flanders",
    stars: 5,
    description:
      "TLDR: Carbon is like Oxide 2.0++ Enhanced Edition. 6/5 would recommend. I was very hesitant switching my server over to carbon. Ill say it has been the best decision I have ever made. it feels like everything that oxide should have and more. So much more information, so much more handy tools and the UI is perfect. There is so many good things with carbon that I will highly recommend and server owner to experience the difference for themselves to make the decision.",
  }
];

export default Reviews;
